import { appendLineStrings } from './appendLineStrings';
export const getJoinedFeatures = (features) => {
    let coordinates = [];
    for (const feature of features) {
        if (feature.geometry.type !== 'MultiLineString') {
            throw new Error(`[joinLineTool] Cannot join ${feature.geometry.type}, only MultiLineString is supported`);
        }
        coordinates = [...coordinates, ...feature.geometry.coordinates];
    }
    const newMultiLineGeometry = coordinates.reduce(appendLineStrings, []);
    return {
        ...features[0],
        geometry: {
            coordinates: newMultiLineGeometry,
            type: 'MultiLineString',
        },
    };
};
//# sourceMappingURL=getJoinedFeatures.js.map